import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-252">
      <div className="max-w-3xl mx-auto text-center" data-id="element-253">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-254">
          Si sos profe de pádel en Argentina,
          <br data-id="element-255" />
          <span className="text-[#00B4D8]" data-id="element-256">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-257">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-258">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-259">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-260">
              Llegás a la cancha sin saber exactamente qué ejercicio vas a dar
              hoy
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-261">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-262">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-263">
              Tus alumnos más principiantes no progresan porque no tenés una
              secuencia clara de niveles
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-264">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-265">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-266">
              El 60% de los alumnos abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-267">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-268">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-269">
              Cuando llueve cancelás y perdés el ingreso porque no tenés un Plan
              B listo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-270">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-271">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-272">
              No podés justificar un aumento de precio porque no tenés un
              sistema profesional visible
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-273">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-274">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-275">
              Siempre las mismas correcciones improvisadas, sin un método claro
              que te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-276">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-277">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-278">
              Tenés alumnos de distintos niveles juntos y la clase se convierte
              en un caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-279">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-280">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-281">
              Fin de mes y no sabés exactamente cuánto vas a cobrar porque el
              cobro es un desastre
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-282">
          ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-283" />
      </div>
    </section>;
}